/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Price_AcInputs */

const en_pc_cmp_r_price_ac = /** @type {(inputs: Pc_Cmp_R_Price_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader is free. Standard US$14.99, Pro US$19.99, Studio US$24.99 a month on an annual plan`)
};

const zh_pc_cmp_r_price_ac = /** @type {(inputs: Pc_Cmp_R_Price_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reader 免费。年付方案下 Standard 每月 14.99 美元、Pro 19.99 美元、Studio 24.99 美元`)
};

/**
* | output |
* | --- |
* | "Reader is free. Standard US$14.99, Pro US$19.99, Studio US$24.99 a month on an annual plan" |
*
* @param {Pc_Cmp_R_Price_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_price_ac = /** @type {((inputs?: Pc_Cmp_R_Price_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Price_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_price_ac(inputs)
	return zh_pc_cmp_r_price_ac(inputs)
});
export { pc_cmp_r_price_ac as "pc.cmp.r.price.ac" }